import React from 'react';
import Flag from './Flag';

// Second marquee (below the hero): world-brand supplements + country flags.
// Two identical groups + a -50% scroll = a seamless loop with no empty gap.
const FLAGS = [
  { code: 'EU', name: 'Європи' },
  { code: 'US', name: 'Америки' },
  { code: 'GB', name: 'Великої Британії' },
  { code: 'UA', name: 'України' },
];

const Group = () => (
  <div className="flex items-center gap-x-3 pr-8 whitespace-nowrap shrink-0">
    <span className="font-semibold">Вітаміни, мінерали та спортивне харчування відомих світових брендів</span>
    <span className="text-[var(--msa-green)]">♥</span>
    {FLAGS.map((f) => (
      <span key={f.name} className="inline-flex items-center gap-1.5">
        <Flag code={f.code} />{f.name}
      </span>
    ))}
    <span className="text-[var(--msa-green)]">♥</span>
    <span className="text-[var(--msa-green)] font-bold">*понад 2000 товарів</span>
    <span className="opacity-25 pl-2">•</span>
  </div>
);

// One animated half. It must be at least as wide as the widest viewport,
// otherwise translateX(-50%) reveals a blank gap on wide screens before the
// next copy scrolls in. Three groups (~4000px) covers 4K displays; the two
// halves together give the seamless -50% loop.
const Half = () => (
  <div className="flex shrink-0">
    <Group />
    <Group />
    <Group />
  </div>
);

const BrandsBar = () => (
  <div className="w-full bg-[var(--msa-ink)] text-white overflow-hidden mt-5 sm:mt-7">
    <div className="flex w-max py-2.5 text-[13px]"
      style={{ animation: 'msa-scroll 78s linear infinite' }}>
      <Half />
      <Half />
    </div>
  </div>
);

export default BrandsBar;
